
define('text!modules/shared/templates/strategy_list.html',[],function () { return '<div class="strategy-list-list-container"></div>';});

